<template>
	<div class="scroll">
		<NavHeader/>
		<div>
			<router-view></router-view>
		</div>
		<Footer />
		<Backup />
	</div>
</template>

<script>
import Backup from './components/Backup.vue';
import Footer from './components/Footer.vue';
import NavHeader from './components/Nav.vue';
export default {
	components: { NavHeader, Footer, Backup },
	data() {
		return {}
	},
	mounted(){
		// setTimeout(()=>{
		// 	this.$router.push({
		// 		path:'/'
		// 	})
		// },1000)


	}
}
</script>

<style lang="less" scoped>
#app {
  padding: 0;
  margin: 0;
}

</style>
